<template>
   <div class="hello" >
      <div>
        	<div class="calc_name">
        		<span class="font_name">{{ name }}</span>
        	</div> 
             <div v-if="minus===0"></div>
        	<div  v-else :class="minus>0? 'calc_accow_red':'calc_accow'" ></div>
         
        	<div class="clear"></div>   	
      </div>
  
      	<div>
      	    <div  style="float:left;padding-top:20px;">
      	             <ul   style="text-align:left;" :class="minus>0? 'font_red':'font_green'" > 
                      <span class="font_minus"> {{ minus >0 ? '+'+minus : minus }}</span>
                      <span class="font_unit">{{ unit }}</span> 
      	             </ul>
      	    </div> 
             <div style="float:right;">
                      <ul style="padding-top:26px;">
                            <li class="font_value_s">{{ value[0] }}</li><li class="font_unit_s">{{ unit }}</li> 
                            <li v-if="minus===0" class="accow_gray"></li>
                            <li v-else :class="minus>0? 'accow_red':'accow_green'" > </li>
                            <li class="font_value_s">{{ value[1] }}</li><li class="font_unit_s">{{ unit }}</li>
                      </ul> 
            </div> 
          <div class="clear"></div>
      	</div> 
         
    </div> 
</template>

<script>
export default {
  // 接收父组件传过来的属性
  props: ['name', 'value', 'minus', 'unit']
}
</script> 



// WEBPACK FOOTER //
// Standard.vue?59b86344